export const USER_TYPE_ADMIN = 'SDM'
export const USER_TYPE_USER = 'INST'